// extends
import { ExtendedContainer, ExtendedGraphics, ExtendedSprite } from "@aceroll/core";

// platform
import { platform } from '@aceroll/core';

// game-objects
import { Logo } from "../gameObjects";

export default class ProgressScreen extends ExtendedContainer {
    constructor() {
        super();

        this._mask = null;
        this._maskWidth = 0;
        this._content = new ExtendedContainer('Content Container');

        this.addLogo();
        this.addHacksawLogo();
        this.createProgressBar();
        this.addChild(this._content);

        platform.onLoadingProgress(this.updateMask.bind(this))
    }



    addLogo() {
        this._logoAnimated = new Logo();
        this._logoAnimated.position.set(0, 60);
        this._logoAnimated.show();
        this._content.addChild(this._logoAnimated);

        this._logoSkyGaming = this._content.addChild(ExtendedSprite.fromSpriteSheet('preloader-ace_roll_logo'));
        this._logoSkyGaming.anchor.set(0.5);
        this._logoSkyGaming.scale.set(0.35);
        this._logoSkyGaming.position.set(0, -388);
    }

    addHacksawLogo() {
        this._logo = this._content.addChild(ExtendedSprite.fromSpriteSheet('preloader-hacksaw'));
        this._logo.anchor.set(0.5, 0.5);
        this._logo.position.set(-1, 464);
    }

    createProgressBar() {
        this._progressBar = this._content.addChild(new ExtendedContainer('Porgress Bar'));

        const loaderBack = ExtendedSprite.fromSpriteSheet('preloader-loader_back');
        loaderBack.scale.set(0.9, 1);
        loaderBack.anchor.set(0.5, 0.5);

        const loaderBackDiamond = ExtendedSprite.fromSpriteSheet('preloader-loader_fill_dark');
        loaderBackDiamond.anchor.set(0.5, 0.5);

        const loaderFill = ExtendedSprite.fromSpriteSheet('preloader-loader_fill');
        loaderFill.anchor.set(0.5, 0.5);

        const loaderFrame = ExtendedSprite.fromSpriteSheet('preloader-loader_frame');
        loaderFrame.scale.set(0.99, 0.99);
        loaderFrame.anchor.set(0.5, 0.5);

        const mask = new ExtendedGraphics('progress-mask');
        mask.beginFill(0xffffff);
        mask.drawRect(0, -loaderFill.height / 2, loaderFill.width, loaderFill.height);
        mask.endFill();
        mask.scale.x = 0;
        mask.position.set(loaderFill.x - loaderFill.width / 2, loaderFill.y);
        loaderFill.mask = mask;

        this._progressBarMask = mask;

        this._progressBar.addChild(loaderBack);
        this._progressBar.addChild(loaderBackDiamond);
        this._progressBar.addChild(loaderFill);
        this._progressBar.addChild(mask);
        this._progressBar.addChild(loaderFrame);
        this._progressBar.position.set(0, 216);
    }

    updateMask(progress) {
        const clampedProgress = Math.min(100, Math.max(0, progress));
        this._progressBarMask.scale.x = clampedProgress / 100;
    }

    hide() {
        this._logoAnimated.hide();
    }
}
